import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-020ed659"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gridEncontrar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-plus",
  _mstvisible: "2"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Agregar Ingreso ")
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "form-floating mb-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "buscar" }, "Buscar por Expediente No.:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push(`/ingresos/new`))),
      type: "button",
      class: "btn btn-outline-success"
    }, _hoisted_4),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          id: "search",
          type: "buscar",
          placeholder: "Buscar",
          class: "form-control",
          autofocus: "",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($data.term) = $event)),
          onKeypress: _cache[2] || (_cache[2] = _withKeys(($event: any) => ($props.search($data.term)), ["enter"]))
        }, null, 544), [
          [_vModelText, $data.term]
        ]),
        _hoisted_6
      ])
    ])
  ]))
}